export const ru = {
    'campaign-events': 'События этой кампании',
    'change-traffic-value': 'Изменение объема трафика',
    'current-balance': 'Остаток средств',
    'email-empty': 'Не задан адрес электронной почты',
    'end-campaign': 'Об окончании кампании',
    'increase-balance': 'Поступление средств',
    'moderation-results': 'О результатах модерации',
    'monitoring-results': 'О результатах мониторинга сайта',
    'percent-of-current-balance': 'Уровень остатка средств на кампании',
    'percent-of-current-balance-warning-empty':
        'Не задан уровень остатка средств',
    'percent-of-current-balance-warning-interval':
        'Уровень остатка средств должен быть в интервале от {min} до {max}',
    'stop-by-reach-daily-budget': 'Остановка по достижению дневного бюджета',
    'xls-ready': 'Готовность XLS-отчетов'
};
